"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
class ConsentManager {
    submitConsent(name, version) {
        window.dataLayer.push({
            event: "trackSamtykke",
            samtykkehandling: "samtykke givet",
            samtykkenavn: (0, helpers_1.toLowerOrEmpty)(name),
            samtykkeversion: (0, helpers_1.toLowerOrEmpty)(version)
        });
    }
    removeConsent(name, version) {
        window.dataLayer.push({
            event: "trackSamtykke",
            samtykkehandling: "samtykke fjernet",
            samtykkenavn: (0, helpers_1.toLowerOrEmpty)(name),
            samtykkeversion: (0, helpers_1.toLowerOrEmpty)(version)
        });
    }
    requestConsent(name, version) {
        window.dataLayer.push({
            event: 'trackSamtykke',
            samtykkehandling: "samtykke efterspurgt",
            samtykkenavn: (0, helpers_1.toLowerOrEmpty)(name),
            samtykkeversion: (0, helpers_1.toLowerOrEmpty)(version)
        });
    }
}
exports.default = ConsentManager;
